export default __webpack_public_path__ + "static/media/ic_weather_16.b8e5b2c3.svg";